import { BaseApi } from './base.api'

export class AgentsAdminApi extends BaseApi {
	constructor() {
		super('api/admin/agents')
	}

	async generateDictionaryDefinition(data) {
		return this.post('/dictionary/generate-definition', data)
	}

	async previewGenerateDictionaryDefinitionPrompt(data) {
		return this.post('/dictionary/generate-definition/prompt-preview', data)
	}

	async generateDictionaryExample(data) {
		return this.post('/dictionary/generate-example', data)
	}

	async previewGenerateDictionaryExamplePrompt(data) {
		return this.post('/dictionary/generate-example/prompt-preview', data)
	}

	async getProductOwnerIdeaDrafts() {
		return this.get('/product-owner/idea-drafts')
	}

	async getProductOwnerAIStats() {
		return this.get('/product-owner/ai-stats')
	}

	async createProductOwnerIdeaDraft(data) {
		return this.post('/product-owner/idea-drafts', data)
	}

	async updateProductOwnerIdeaDraft(id, data) {
		return this.put(`/product-owner/idea-drafts/${id}`, data)
	}

	async deleteProductOwnerIdeaDraft(id) {
		return this.delete(`/product-owner/idea-drafts/${id}`)
	}

	async updateProductOwnerIdeaApproval(id, approved) {
		return this.put(`/product-owner/idea-drafts/${id}/approval`, {
			approved,
		})
	}

	async refineProductOwnerIdeaDraft(id, feedback) {
		return this.post(`/product-owner/idea-drafts/${id}/refine`, {
			feedback,
		})
	}

	async previewRefineProductOwnerIdeaDraftPrompt(id, feedback) {
		return this.post(`/product-owner/idea-drafts/${id}/refine/prompt-preview`, {
			feedback,
		})
	}

	async explainProductOwnerIdeaDraft(id) {
		return this.post(`/product-owner/idea-drafts/${id}/explain`)
	}

	async previewExplainProductOwnerIdeaDraftPrompt(id, focus = '') {
		return this.post(`/product-owner/idea-drafts/${id}/explain/prompt-preview`, {
			focus,
		})
	}

	async generateProductOwnerIdeaDraft(prompt = '') {
		return this.post('/product-owner/generate-idea-draft', { prompt })
	}

	async previewProductOwnerGeneratePrompt(prompt = '') {
		return this.post('/product-owner/generate-idea-draft/prompt-preview', {
			prompt,
		})
	}

	async getActiveAgentConfig(agentKey) {
		return this.get(`/agent-configs/${agentKey}/active`)
	}

	async updateActiveAgentConfig(agentKey, data) {
		return this.put(`/agent-configs/${agentKey}/active`, data)
	}
}
